import { render, staticRenderFns } from "./WSuggestion.vue?vue&type=template&id=58ffc850&scoped=true&lang=pug&"
import script from "./WSuggestion.vue?vue&type=script&lang=js&"
export * from "./WSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./WSuggestion.vue?vue&type=style&index=0&id=58ffc850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffc850",
  null
  
)

export default component.exports